import { toast } from "react-toastify";
import { DeleteFileAPI } from "../../../API/FilesAPI";
import { IResponseProps } from "../../../Interfaces/IResponseProps";
import { FileModel } from "../../../Models/FileModel";
import { FilesColumns } from "../../../Static/FilesColumns";
import TableDefault from "../../Shared/TableDefault";

interface IFileTableComponentProps {
    toggleLoading: (data: boolean) => void,
    getFiles: (page?: number) => Promise<void>,
    setSearchText: React.Dispatch<React.SetStateAction<string>>,
    files: FileModel[],
    total: number,
    checkedState: any[],
    setCheckedState: React.Dispatch<React.SetStateAction<any[]>>,
    canNotDoNothing: boolean,
    companyId: string
}

const FileTableComponent = (props: IFileTableComponentProps) => {

    const deleteFile = async (fileId: string) => {
        try {
            props.toggleLoading(true);

            await DeleteFileAPI(fileId, props.companyId).then((resp: IResponseProps) => {
                if (resp.statusCode == 200) {
                    toast.success("Arquivo deletado com sucesso!");
                    props.getFiles();
                }
            }).finally(() => props.toggleLoading(false));
        } catch (error: any) {
            toast.error(error);
            props.toggleLoading(false);
        }
    }

    return (
        <div className="d-flex flex-column w-100 me-1">
            <input className="form-control mb-2 w-25 align-self-end" onBlur={() => props.getFiles()} placeholder="buscar arquivo..." onChange={(e) => props.setSearchText(e.target.value)} />
            <TableDefault
                columns={FilesColumns}
                hasHeader={true}
                hasPagination={true}
                rows={props.files}
                ColumnWithButton={0}
                lastColumnIsAction={!props.canNotDoNothing}
                hasDelete={true}
                isFiles={true}
                total={props.total}
                changePage={props.getFiles}
                firstColumnIsCheck={true}
                functionToDelete={deleteFile}
                checkedState={props.checkedState}
                setCheckedState={props.setCheckedState}
            />
        </div>
    )
}

export default FileTableComponent;